import { Tooltip } from "react-tooltip"
import styled from "styled-components"

import { ReactComponent as IconClock } from "assets/svg/monitoringSchedule/clock.svg"
import { ReactComponent as IconHold } from "assets/svg/monitoringSchedule/hold.svg"
import { ReactComponent as IconHome } from "assets/svg/monitoringSchedule/home.svg"
import { ReactComponent as IconKey } from "assets/svg/monitoringSchedule/key.svg"
import { ReactComponent as IconMoon } from "assets/svg/monitoringSchedule/moon.svg"

import { ScheduleBucketKey } from "./getScheduleDataArray"

const Container = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
`

const ScheduleComponent = styled.div<{ visible: boolean }>`
  height: 100%;
  display: flex;
  align-items: center;
  gap: 4px;
  line-height: 24px;
  background-color: rgba(30, 41, 59, 0.08);
  overflow: hidden;
  border-left: 3px solid #fff;
  font-size: 12px;
  text-transform: capitalize;
  ${({ visible }) => !visible && "visibility: hidden;"}

  &:first-child {
    border-left: none;
  }
`

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-left: 8px;

  svg {
    width: 100%;
    height: 100%;
  }
`

const TooltipContent = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  text-transform: capitalize;
`

const TooltipIconWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;

  svg {
    width: 100%;
    height: 100%;
    fill: white;

    path {
      fill: white;
    }
  }
`

interface ScheduleComponentsProps {
  overallDocsCount: number
  scheduleData: { type: ScheduleBucketKey; value: number }[]
}

const getScheduleIcon = (type: ScheduleBucketKey) => {
  switch (type) {
    case "wake":
      return <IconClock />
    case "sleep":
      return <IconMoon />
    case "home":
      return <IconHome />
    case "away":
      return <IconKey />
    case "hold":
      return <IconHold />
    case "none":
    default:
      return null
  }
}

const ScheduleComponents = ({ scheduleData, overallDocsCount }: ScheduleComponentsProps) => {
  return (
    <Container>
      {scheduleData.map((item, index) => {
        const icon = getScheduleIcon(item.type)
        const tooltipId = `schedule-tooltip-${item.type}-${index}`
        const capitalizedType = item.type.charAt(0).toUpperCase() + item.type.slice(1)

        return (
          <>
            <ScheduleComponent
              key={`${item.type}-${index}`}
              style={{ width: `${(item.value / overallDocsCount) * 100}%` }}
              visible={item.type !== "none"}
              data-tooltip-id={tooltipId}
            >
              {icon && <IconWrapper>{icon}</IconWrapper>}
              {item.type}
            </ScheduleComponent>
            {item.type !== "none" && (
              <Tooltip id={tooltipId} place="top" variant="dark">
                <TooltipContent>
                  {icon && <TooltipIconWrapper>{icon}</TooltipIconWrapper>}
                  {capitalizedType}
                </TooltipContent>
              </Tooltip>
            )}
          </>
        )
      })}
    </Container>
  )
}

export default ScheduleComponents
